"use client"; // Required for React hooks

import { createContext, useContext } from "react";

// Create the context
const LayoutDataContext = createContext<unknown | null>(null);

// Provider to wrap children with the data
export function LayoutDataProvider<T>({ children, value }: { children: React.ReactNode; value: T }) {
  return <LayoutDataContext.Provider value={value}>{children}</LayoutDataContext.Provider>;
}

// Hook to use the context
export function useLayoutData<T>() {
  const context = useContext(LayoutDataContext) as T;
  if (!context) throw new Error("Use layout data is outside context");
  return context;
}
